<template>
    <div>
        <div class="loader" v-if="this.isLoading"></div>
        <div class="loadertext" v-if="this.isLoading"> {{ $t('loadingTxt') }}...</div>
        <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">

            <!--begin::navbar-->
            <navbar-component></navbar-component>
            <!--end::navbar-->

            <div class="page-wrapper">

                <!--begin::content-->
                <div class="page-content">
                    <div class="row">
                        <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                            <div class="card">
                                <div class="card-header">
                                    <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                                    &nbsp;&nbsp;&nbsp;
                                    <h6 class="card-title mb-0 float-start" style="padding-left: 25px">Edit ASN</h6>
                                    <button class="btn btn-default btn-sm float-end" @click="resetForm" type="button">
                                        <i class="link-icon" data-feather="repeat"></i>
                                        {{ $t("resetFormTxt") }}
                                    </button>
                                </div>
                                <div class="card-body">

                                    <form class="forms-sample" @submit.prevent="submitData" method="POST">


                                        <ul class="nav nav-tabs nav-tabs-line" id="lineTab" role="tablist">
                                            <li class="nav-item">
                                                <a class="nav-link active" id="home-line-tab" data-bs-toggle="tab"
                                                    href="#home" role="tab" aria-controls="home" aria-selected="true">Main
                                                    Info</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" id="contact-line-tab" data-bs-toggle="tab"
                                                    href="#contact" role="tab" aria-controls="contact"
                                                    aria-selected="false">Contact</a>
                                            </li>

                                            <li class="nav-item">
                                                <a class="nav-link" id="userDefine-line-tab" data-bs-toggle="tab"
                                                    href="#userDefine" role="tab" aria-controls="disabled"
                                                    aria-selected="false">User Defined</a>
                                            </li>



                                        </ul>
                                        <div class="tab-content mt-3" id="lineTabContent">
                                            <div class="tab-pane fade show active" id="home" role="tabpanel"
                                                aria-labelledby="home-line-tab">

                                                <div class="row mb-2">

                                                    <div class="col-lg-3">
                                                        <label for="defaultconfig" class="col-form-label required">{{
                                                            $t('customerId')
                                                        }}</label>

                                                        <v-select :options="fetchCustomer" v-model="customer" label="code"
                                                            return-object @search="asyncCustomer">
                                                            <template slot="option" slot-scope="option">
                                                                {{ option.code }} | {{ option.name }}
                                                            </template>
                                                        </v-select>

                                                        <div v-if="errors.customer_id">
                                                            <div v-for="error in errors.customer_id" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label required">Vendor Code</label>

                                                        <input type="text" class="form-control" id="customerId"
                                                            placeholder="Customer Id" v-model="forms.customerId" />

                                                        <div v-if="errors.customerId">
                                                            <div v-for="error in errors.customerId" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>

                                                    </div>


                                                    <div class="col-lg-3">
                                                        <label for="defaultconfig" class="col-form-label required">Customer
                                                            Type</label>

                                                        <v-select :options="fetchVendorType" v-model="customerType"
                                                            label="name" return-object>
                                                            <!-- <template slot="option" slot-scope="option">
                                      {{ option.customer_id}} | {{option.code}} | {{option.name}}
                                </template> -->
                                                        </v-select>
                                                        <div v-if="errors.customerType">
                                                            <div v-for="error in errors.customerType" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>

                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label required">Customer
                                                            Description 1</label>

                                                        <input type="text" class="form-control" id="customerDescr1"
                                                            placeholder="Customer Description"
                                                            v-model="forms.customerDescr1" />

                                                        <div v-if="errors.customerDescr1">
                                                            <div v-for="error in errors.customerDescr1" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label required">Customer
                                                            Description 2</label>

                                                        <input type="text" class="form-control" id="customerDescr2"
                                                            placeholder="Customer Description 2"
                                                            v-model="forms.customerDescr2" />

                                                        <div v-if="errors.customerDescr2">
                                                            <div v-for="error in errors.customerDescr2" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div class="row mb-2">

                                                    <div class="col-lg-2">

                                                        <label for="defaultconfig" class="col-form-label"></label>

                                                        <div class="form-check mb-3">
                                                            <input type="checkbox" class="form-check-input" id="activeFlag"
                                                                v-model="activeFlag">
                                                            <label class="form-check-label" for="activeFlag">
                                                                Active Flag
                                                            </label>
                                                        </div>

                                                        <div v-if="errors.activeFlag">
                                                            <div v-for="error in errors.activeFlag" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label required">Ref
                                                            Owner</label>

                                                        <input type="text" class="form-control" id="refOwner" placeholder=""
                                                            v-model="forms.refOwner" />

                                                        <div v-if="errors.refOwner">
                                                            <div v-for="error in errors.refOwner" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label required">Easy
                                                            Code</label>

                                                        <input type="text" class="form-control" id="easyCode" placeholder=""
                                                            v-model="forms.easyCode" />

                                                        <div v-if="errors.easyCode">
                                                            <div v-for="error in errors.easyCode" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig"
                                                            class="col-form-label required">Country</label>

                                                        <input type="text" class="form-control" id="country" placeholder=""
                                                            v-model="forms.country" />

                                                        <div v-if="errors.country">
                                                            <div v-for="error in errors.country" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig"
                                                            class="col-form-label required">Province</label>

                                                        <input type="text" class="form-control" id="province" placeholder=""
                                                            v-model="forms.province" />

                                                        <div v-if="errors.province">
                                                            <div v-for="error in errors.province" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig"
                                                            class="col-form-label required">City</label>

                                                        <input type="text" class="form-control" id="province" placeholder=""
                                                            v-model="forms.city" />

                                                        <div v-if="errors.city">
                                                            <div v-for="error in errors.city" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>







                                                </div>




                                                <div class="row mb-2">
                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">District</label>
                                                        <input type="text" class="form-control" id="district"
                                                            placeholder="District" v-model="forms.district" />
                                                        <div v-if="errors.district">
                                                            <div v-for="error in errors.district" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Street</label>
                                                        <input type="text" class="form-control" id="street"
                                                            placeholder="Street" v-model="forms.street" />
                                                        <div v-if="errors.street">
                                                            <div v-for="error in errors.street" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Zip Code</label>
                                                        <input type="text" class="form-control" id="zipCode"
                                                            placeholder="Zip Code" v-model="forms.zipCode" />
                                                        <div v-if="errors.zipCode">
                                                            <div v-for="error in errors.zipCode" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>

                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Currency</label>
                                                        <input type="text" class="form-control" id="currency"
                                                            placeholder="Currency" v-model="forms.currency" />
                                                        <div v-if="errors.currency">
                                                            <div v-for="error in errors.currency" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Bank
                                                            Account</label>
                                                        <input type="text" class="form-control" id="bankAccount"
                                                            placeholder="Bank Account" v-model="forms.bankAccount" />
                                                        <div v-if="errors.bankAccount">
                                                            <div v-for="error in errors.bankAccount" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Route Code</label>
                                                        <input type="text" class="form-control" id="routeCode"
                                                            placeholder="Route Code" v-model="forms.routeCode" />
                                                        <div v-if="errors.routeCode">
                                                            <div v-for="error in errors.routeCode" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>




                                                </div>


                                                <div class="row mb-2">
                                                    <div class="col-lg-12">
                                                        <label for="defaultconfig" class="col-form-label">Note</label>
                                                        <textarea class="form-control" name="noteTxt"
                                                            v-model="forms.noteText"></textarea>
                                                        <div v-if="errors.noteText">
                                                            <div v-for="error in errors.noteText" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>



                                            </div>
                                            <div class="tab-pane fade" id="contact" role="tabpanel"
                                                aria-labelledby="contact-line-tab">
                                                <div class="row mb-2">

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label required">Contact
                                                            1</label>
                                                        <input type="text" class="form-control" id="contact1" placeholder=""
                                                            v-model="forms.contact1" />
                                                        <div v-if="errors.contact1">
                                                            <div v-for="error in errors.contact1" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label required">Contact
                                                            Title 1</label>
                                                        <input type="text" class="form-control" id="contact1_title"
                                                            placeholder="" v-model="forms.contact1_title" />
                                                        <div v-if="errors.contact1_title">
                                                            <div v-for="error in errors.contact1_title" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Contact 1
                                                            Email</label>
                                                        <input type="text" class="form-control" id="contact1_email"
                                                            placeholder="" v-model="forms.contact1_email" />

                                                        <div v-if="errors.contact1_email">
                                                            <div v-for="error in errors.contact1_email" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Contact 1
                                                            fax</label>
                                                        <input type="text" class="form-control" id="contact1_fax"
                                                            placeholder="" v-model="forms.contact1_fax" />

                                                        <div v-if="errors.contact1_fax">
                                                            <div v-for="error in errors.contact1_fax" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Contact Telp
                                                            1</label>
                                                        <input type="text" class="form-control" id="contact1_tel1"
                                                            placeholder="" v-model="forms.contact1_tel1" />

                                                        <div v-if="errors.contact1_tel1">
                                                            <div v-for="error in errors.contact1_tel1" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Contact Telp
                                                            2</label>
                                                        <input type="text" class="form-control" id="contact1_tel2"
                                                            placeholder="" v-model="forms.contact1_tel2" />

                                                        <div v-if="errors.contact1_tel2">
                                                            <div v-for="error in errors.contact1_tel2" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>





                                                </div>


                                                <div class="row mb-2">

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label required">Contact
                                                            2</label>
                                                        <input type="text" class="form-control" id="contact1" placeholder=""
                                                            v-model="forms.contact2" />
                                                        <div v-if="errors.contact2">
                                                            <div v-for="error in errors.contact2" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label required">Contact
                                                            Title 2</label>
                                                        <input type="text" class="form-control" id="contact2_title"
                                                            placeholder="" v-model="forms.contact2_title" />
                                                        <div v-if="errors.contact2_title">
                                                            <div v-for="error in errors.contact2_title" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Contact 2
                                                            Email</label>
                                                        <input type="text" class="form-control" id="contact2_email"
                                                            placeholder="" v-model="forms.contact2_email" />

                                                        <div v-if="errors.contact2_email">
                                                            <div v-for="error in errors.contact2_email" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Contact 2
                                                            fax</label>
                                                        <input type="text" class="form-control" id="contact2_fax"
                                                            placeholder="" v-model="forms.contact2_fax" />

                                                        <div v-if="errors.contact2_fax">
                                                            <div v-for="error in errors.contact2_fax" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Contact 2 Telp
                                                            1</label>
                                                        <input type="text" class="form-control" id="contact1_tel1"
                                                            placeholder="" v-model="forms.contact2_tel1" />

                                                        <div v-if="errors.contact2_tel1">
                                                            <div v-for="error in errors.contact2_tel1" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Contact 2 Telp
                                                            2</label>
                                                        <input type="text" class="form-control" id="contact1_tel2"
                                                            placeholder="" v-model="forms.contact2_tel2" />

                                                        <div v-if="errors.contact2_tel2">
                                                            <div v-for="error in errors.contact1_tel2" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>





                                                </div>


                                                <div class="row mb-2">

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label required">Contact
                                                            3</label>
                                                        <input type="text" class="form-control" id="contact1" placeholder=""
                                                            v-model="forms.contact3" />
                                                        <div v-if="errors.contact3">
                                                            <div v-for="error in errors.contact3" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label required">Contact
                                                            Title 3</label>
                                                        <input type="text" class="form-control" id="contact2_title"
                                                            placeholder="" v-model="forms.contact3_title" />
                                                        <div v-if="errors.contact3_title">
                                                            <div v-for="error in errors.contact3_title" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Contact 3
                                                            Email</label>
                                                        <input type="text" class="form-control" id="contact2_email"
                                                            placeholder="" v-model="forms.contact3_email" />

                                                        <div v-if="errors.contact3_email">
                                                            <div v-for="error in errors.contact3_email" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Contact 3
                                                            fax</label>
                                                        <input type="text" class="form-control" id="contact2_fax"
                                                            placeholder="" v-model="forms.contact3_fax" />

                                                        <div v-if="errors.contact3_fax">
                                                            <div v-for="error in errors.contact3_fax" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Contact 3 Telp
                                                            1</label>
                                                        <input type="text" class="form-control" id="contact1_tel1"
                                                            placeholder="" v-model="forms.contact3_tel1" />

                                                        <div v-if="errors.contact3_tel1">
                                                            <div v-for="error in errors.contact3_tel1" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">Contact 3 Telp
                                                            2</label>
                                                        <input type="text" class="form-control" id="contact1_tel2"
                                                            placeholder="" v-model="forms.contact3_tel2" />

                                                        <div v-if="errors.contact3_tel2">
                                                            <div v-for="error in errors.contact1_tel2" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>





                                                </div>




                                            </div>

                                            <div class="tab-pane fade" id="userDefine" role="tabpanel"
                                                aria-labelledby="userDefine-line-tab">

                                                <div class="row mb-3">
                                                    <div class="col-lg-3">
                                                        <label for="defaultconfig" class="col-form-label">UDF 1</label>
                                                        <input type="text" class="form-control" id="udf01" placeholder=""
                                                            v-model="forms.udf01" />
                                                        <div v-if="errors.udf01">
                                                            <div v-for="error in errors.udf01" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">UDF 2</label>
                                                        <input type="text" class="form-control" id="udf02" placeholder=""
                                                            v-model="forms.udf02" />
                                                        <div v-if="errors.udf02">
                                                            <div v-for="error in errors.udf02" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">UDF 3</label>
                                                        <input type="text" class="form-control" id="udf03" placeholder=""
                                                            v-model="forms.udf03" />
                                                        <div v-if="errors.udf03">
                                                            <div v-for="error in errors.udf03" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-2">
                                                        <label for="defaultconfig" class="col-form-label">UDF 4</label>
                                                        <input type="text" class="form-control" id="udf04" placeholder=""
                                                            v-model="forms.udf04" />
                                                        <div v-if="errors.udf04">
                                                            <div v-for="error in errors.udf04" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-lg-3">
                                                        <label for="defaultconfig" class="col-form-label">UDF 5</label>
                                                        <input type="text" class="form-control" id="udf05" placeholder=""
                                                            v-model="forms.udf05" />
                                                        <div v-if="errors.udf05">
                                                            <div v-for="error in errors.udf05" :key="error"
                                                                class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>





                                            </div>









                                        </div>




                                        <div class="card-footer">
                                            <button class="
        btn btn-warning
        text-black
        fw-bolder
        btn-icon-text
      " @click="backForm" type="button">
                                                <i class="link-icon" data-feather="arrow-left"></i>
                                                {{ $t("backMess") }}
                                            </button>
                                            &nbsp;&nbsp;&nbsp;
                                            <button class="btn btn-primary float-end btn-sm" type="submit">
                                                <i class="link-icon" data-feather="save"></i>
                                                Save All
                                            </button>
                                        </div>
                                    </form>

                                </div>
                            </div> <!--end::card-->
                        </div>
                    </div>
                </div>
                <!--end::content-->

                <!--begin::footer-->
                <footer-component></footer-component>
                <!--end::footer-->
            </div>
        </div>
    </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
// import DateRangePicker from "vue2-daterange-picker";
// import multiselect from "vue-multiselect";
import { mask } from 'vue-the-mask'

export default {
    name: "CmlTarifAdd",
    props: {},
    directives: { mask },
    components: {
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        // DateRangePicker,
        // multiselect
    },
    data() {
        const startDate = new Date();// new Date();
        const endDate = new Date();

        return {
            dateFilter: {
                startDate,
                endDate,
            },

            fetchVendorType: [],
            customerType: '',


            expectedShipmentTime1dateFilter: {
                startDate,
                endDate,
            },

            requiredDeliveryTimedateFilter: {
                startDate,
                endDate,
            },

            opens: "center",
            locale: {
                format: "yyyy-mm-dd H:MM:ss",
            },

            localeDetail: {
                format: "yyyy-mm-dd",
            },

            highlighted: {

                dates: [ // Highlight an array of dates
                    new Date(),
                ],

            },

            digit: {
                decimal: ',',
                thousands: '.',
                prefix: ' ',
                suffix: '',
                precision: 5,
                masked: false
            },
            fetchStockCondition: [],
            detailAsn: [],
            fetchAsnType: [],
            asnType: [],
            orderType: '',
            fetchOrderType: [],
            shelfLifeUnit: {},
            shelfLifeType: {},
            permision_role: [],
            isLoading: false,
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            errors: [],
            userData: "",
            userRole: "",
            companyCode: "",
            fetchStatus: ['ACTIVE', 'DEACTIVE'],
            fetchmultiWhFlag: ['Y', 'N'],
            fetchCustomer: [],
            fetchFulfillment: [],
            customer: "",
            fulfillment: "",
            fetchShelfLifeType: [],
            fetchShelfLifeUnit: [],
            fetchSku: [],
            activeFlag: false,
            shelfLifeFlag: false,
            kitFlag: false,
            freePickGift: false,
            forms: {},
        };
    },
    watch: {},
    methods: {



        loadCustomer() {

            const baseURI = this.$settings.endPointFluxOms + "v2/customer/get-data-company-oms";

            return this.$http
                .get(
                    baseURI, { timeout: 10000 }
                )
                .then((response) => {
                    this.fetchCustomer = response.data.datas.data;
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },


        loadFullfilment() {

            const baseURI = this.$settings.endPointFluxOms + "v2/fulfillment/get-data-fulfillment";

            return this.$http
                .get(
                    baseURI, { timeout: 10000 }
                )
                .then((response) => {
                    this.fetchFulfillment = response.data.datas.data;
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },

        loadAsnType() {
            const baseURI = this.$settings.endPointFluxOms + "v2/po/type";
            return this.$http
                .get(
                    baseURI, { timeout: 10000 }
                )
                .then((response) => {
                    this.fetchAsnType = response.data.datas;
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },




        loadStockCondition() {
            const baseURI = this.$settings.endPointFluxOms + "v2/sku/get-data-wms-code?type=DMG_FLG";
            return this.$http
                .get(
                    baseURI, { timeout: 10000 }
                )
                .then((response) => {
                    this.fetchStockCondition = response.data.datas.data;
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },


        loadSKU(params) {
            this.fetchSku = [];
            const baseURI = this.$settings.endPointFluxOms + "v2/sku/index" + params;
            return this.$http
                .get(
                    baseURI, { timeout: 10000 }
                )
                .then((response) => {
                    this.fetchSku = response.data.datas.data;
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },

        asyncSearchSku(ev) {
            const baseURI = this.$settings.endPointFluxOms + "v2/sku/get-data-sku?sku=" + ev;
            return this.$http.get(baseURI).then((response) => {
                this.fetchSKU = response.data.datas.data;
            });
        },

        // asyncSearchSku(ev) {
        //   console.log();
        // // this.fetchSku=[];
        // // const baseURI = this.$settings.endPointFluxOms + "v2/sku/get-data-sku?sku=" + ev;

        // // return this.$http
        // //   .get(
        // //     baseURI, { timeout: 10000 }
        // //   )
        // //   .then((response) => {
        // //     this.fetchSku = response.data.datas;
        // //   }).catch(error => {

        // //     if (error.code == "ECONNABORTED") {
        // //       this.error("Please Check Your Internet Connection");
        // //     }

        // //   });
        // },

        updateStatus(id) {
            this.$swal({
                title: this.$t("areYouSure"),
                text: 'Update Status Order',
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    var formData = {
                        orderStatus: 'NEW',
                    };
                    const baseURI =
                        this.$settings.endPointFluxOms + "v2/so/update-status-order/" + id;
                    this.$http
                        .post(baseURI, formData, { timeout: 10000 })
                        .then((response) => {
                            this.loading();
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                window.location.href = "/flux-oms/asn-inbound/";
                                //   this.loadItems();
                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                        }).catch((error) => {
                            this.loading();

                            if (error.code == "ECONNABORTED") {
                                this.error(this.$t("check_internet_connection_txt"));

                            } else {


                                if (error.code == "ECONNABORTED") {
                                    this.error(this.$t("check_internet_connection_txt"));

                                } else {

                                    if (error.response) {
                                        if (error.response.status === 422) {
                                            this.errors = error.response.data.errors;
                                            this.resultError(error.response.data.errors);
                                        } else if (error.response.status === 401) {
                                            this.logout();
                                        } else if (error.response.status === 403) {
                                            this.$router.push("/authorized-error");
                                        } else if (error.response.status === 500) {
                                            this.$router.push('/server-error');
                                        } else {
                                            this.$router.push('/page-not-found');
                                        }
                                    }

                                }

                            }
                        });
                } else {
                    this.isLoading = false;
                }
            });
        },


        loadData(id) {
            this.isLoading = true;
            const baseURI = this.$settings.endPointFluxOms + "v2/vendor/detail/" + id;

            return this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                this.isLoading = false;
                this.forms = response.data.datas;


                this.customer = {
                    code: this.forms.customerId,
                    customer_id: this.forms.customer_id
                };


                this.customerType = {
                    name: this.forms.customerType
                }
                this.activeFlag = this.forms.activeFlag == 'Y' ? true : false;



                // this.fulfillment    = response.data.datas.fulfillment

            }).catch(error => {

                this.loading();

                if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
                } else {

                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        } else {
                            this.$router.push('/page-not-found');
                        }
                    }

                }

            });
        },


        cekData(index, fieldType) {
            console.log(index);
            console.log(fieldType);
            fieldType[index].skuDescr1 = fieldType[index].sku.skuDescr1;
            // fieldType[index].lading_length = fieldType[index].sku.pcs_length;
            // fieldType[index].lading_width = fieldType[index].sku.pcs_width;
            // fieldType[index].lading_height = fieldType[index].sku.pcs_height;
            // //fieldType[index].package_type = fieldType[index].sku.package_code;    
            // fieldType[index].lading_qty = fieldType[index].sku.lading_qty;
            // fieldType[index].net_weight = fieldType[index].sku.net_weight;
            // fieldType[index].weight = fieldType[index].sku.weight;
            // fieldType[index].volume = fieldType[index].sku.volume;
            // //fieldType[index].qty = 0;  
            // this.loadLadingType(fieldType[index].sku.sku_id);
        },


        asyncSearchFulfillment(ev) {
            this.fetchFulfillment = [];
            const baseURI = this.$settings.endPointFluxOms + "v2/fulfillment/get-data-fulfillment?code=" + ev;

            return this.$http
                .get(
                    baseURI, { timeout: 10000 }
                )
                .then((response) => {
                    this.fetchFulfillment = response.data.datas.data;
                    //console.log(this.fetchFulfillment);
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },


        asyncCustomer(code) {
            this.fetchCustomer = [];
            const baseURI = this.$settings.endPointFluxOms + "v2/customer/get-data-company-oms?code=" + code;

            return this.$http
                .get(
                    baseURI, { timeout: 10000 }
                )
                .then((response) => {
                    this.fetchCustomer = response.data.datas.data;
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },

        resetForm() {

            this.forms = [];

        },

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.userData = userDatas.sub;
            this.userRole = userDatas.sub.role;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'SkuController') {
                    rolePermision = permision;
                    // console.log(permision);
                }
            });

            if (!rolePermision.method_create) {
                this.$router.push("/authorized-error");
            }

            this.permision_role = rolePermision;
            this.loadFullfilment();
            this.loadCustomer();
            this.loadAsnType();
            // this.loadStockCondition();
            // this.loadShelfLifeType();
            // this.loadShelfLifeUnit();

        },

        backForm() {
            window.location.href = "/flux-oms/vendor";
        },



        submitData() {
            this.isLoading = true;



            this.forms.customer_id = this.customer.customer_id;
            this.forms.activeFlag=this.activeFlag==true ? 'Y' : 'N';
            this.forms.customerType = this.customerType.name;


        
            var params = this.$onBehind(this.$route.params.id);
            const baseURI = this.$settings.endPointFluxOms + "v2/vendor/update/" + params[0];
            this.$http.patch(baseURI, this.forms, { timeout: 10000 }).then((response) => {
                this.loading();
                if (response.data.status === 200) {
                    //this.resetForm();
                    this.isLoading = false;
                    this.errors = [];
                    //console.log(response.data.datas.user_id);
                    //var params = this.$onRandom(response.data.datas.BAS_SKU_ID);
                    var params = this.$onRandom(response.data.datas.vendor_id);
                    window.location.href = "/flux-oms/vendor/detail/" + params;
                    this.success('Berhasil');

                } else {
                    this.isLoading = false;
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                }
            }).catch(error => {
                this.loading();
                this.isLoading = false;
                if (error.code == "ECONNABORTED") {
                    this.error("Please Check Your Internet Connection");
                }

                if (error.response) {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                        this.logout();
                    } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                    } else {
                        this.$router.push('/page-not-found');
                    }
                }
                //this.resetForm();
            });

        },


        addFieldDetail() {
            var userModels = JSON.parse(localStorage.getItem('userModels'));

            var params = "";
            if (userModels['sub']['fulfillments'] == null) {
                if (this.customer.customer_id == null) {
                    this.error("Please Select Company");

                } else {
                    params = "?customerId=" + this.customer?.code;
                    this.loadSKU(params);
                }


            } else {
                this.loadSKU(params);
            }


            // const startDate = new Date();// new Date();
            // const endDate = new Date();
            this.detailAsn.push({
                "sku": "",
                "skuDescr": "",
                "expectedQty": 0,
                "totalCubic": 0,
                "totalGrossWeight": 0,
                "totalNetWeight": 0,
                "totalPrice": 0,
                "price": 0,
                "lotAtt01": "",
                "lotAtt02": "",
                "lotAtt03": "",
                "lotAtt04": "",
                "lotAtt05": "",
                "lotAtt06": "",
                "lotAtt07": "",
                "lotAtt08": "",
                "lotAtt09": "",
                "lotAtt10": "",
                "lotAtt11": "",
                "lotAtt12": "",
                "lotAtt13": "",
                "lotAtt14": "",
                "lotAtt15": "",
                "lotAtt16": "",
                "lotAtt17": "",
                "lotAtt18": "",
                "lotAtt19": "",
                "lotAtt20": "",
                "lotAtt21": "",
                "lotAtt22": "",
                "lotAtt23": "",
                "lotAtt24": "",
                "dedi01": "",
                "dedi02": "",
                "dedi03": "",
                "dedi04": "",
                "dedi05": "",
                "dedi06": "",
                "dedi07": "",
                "dedi08": "",
                "dedi09": "",
                "dedi10": "",
                "dedi11": "",
                "dedi12": "",
                "dedi13": "",
                "dedi14": "",
                "dedi15": "",
                "dedi16": "",
                "dedi17": "",
                "dedi18": "",
                "dedi19": "",
                "dedi20": "",
                "noteText": "",
                "containerId": "",
                "userDefine1": "",
                "userDefine2": "",
                "userDefine3": "",
                "userDefine4": "",
                "userDefine5": "",
                "userDefine6": ""

            });





            console.log(this.detailPo);
        },

        removeField(index, fieldType) {
            fieldType.splice(index, 1);
        },

        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },
    },
    events: {},
    created: function () { },
    mounted() {
        this.fetchIt();

        var params = this.$onBehind(this.$route.params.id);
        this.loadData(params[0]);

    },
};
</script>
<style scoped>.required:after {
    content: " *";
    color: red;
}</style>